import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NoDataFound from '../../pages/no-data-found';
class ErrorHandler extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    componentDidCatch() {
        this.setState({ hasError: true });
    }

    render() {
        return this.state.hasError ? <NoDataFound /> : this.props.children;
    }
}

ErrorHandler.propTypes = {
    children: PropTypes.any
};

export default ErrorHandler;
